// Where each desk checklist item is explained: Playbook › 1. The funnel ›
// "Every rule, explained" (playbook/SignalRules.tsx). Its own module so the
// desk can link there without loading the Playbook.

/** Desk checklist item key → its rule card's anchor in the Playbook. */
export const RULE_ANCHOR: Record<string, string> = {
  htf: "rule-4h-bias",
  btc: "rule-btc",
  trend: "rule-1h-trend",
  zone: "rule-zone",
  pullback: "rule-pullback",
  structure: "rule-higher-low",
  trigger: "rule-trigger",
  volume: "rule-volume",
  rsi: "rule-rsi",
  range: "rule-range",
  width: "rule-range",
  boundary: "rule-range",
};

/** The Playbook link for a checklist item, or null when it has no rule card. */
export function ruleHref(key: string): string | null {
  const anchor = RULE_ANCHOR[key];
  return anchor ? `/playbook#${anchor}` : null;
}
